<div id="login-container">
    <div id="login-form-container">
        <!-- PIAS Logo -->
        <p>
            <img src="assets/images/PIAS-logo.png" alt="PIAS-logo" id="pias-logo" class="img img-fluid" />
        </p>

        <!-- Maintenance Card -->
        @if(this.isMaintenanceMode()) {
        <div class="maintenance-card">
            <div class="maintenance-header">
                <i class="bx bx-info-circle maintenance-icon"></i>
                <span class="maintenance-title">{{this.maintenanceType()}}</span>
            </div>

            <p class="maintenance-body">{{this.maintenanceMessage()}}</p>
        </div>
        }
        <div class="card">
            <div class="card-body">
                <p class="card-title mb-4 h4 fw-bold">Login</p>

                <!-- Login Form -->
                <form class="w-100" [formGroup]="loginFg">
                    <p class="w-100">
                        <mat-form-field class="w-100" [hideRequiredMarker]="true">
                            <mat-label>Username</mat-label>
                            <input matInput type="text" formControlName="username" required />
                            @if(this.loginFg.controls["username"].invalid
                            && (this.loginFg.controls["username"].touched || this.loginFg.controls["username"].dirty)
                            ) {
                            <mat-error>
                                @if(this.loginFg.controls["username"].errors?.["required"]) {
                                <span>Username is required.</span>
                                }
                                @else if (this.loginFg.controls["username"].errors?.["username"]) {
                                <span>Invalid username.</span>
                                }
                                @else {
                                <span></span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </p>
                    <p class="w-100">
                        <mat-form-field class="w-100" [hideRequiredMarker]="true">
                            <mat-label>Password</mat-label>
                            <input matInput [type]="passwordHide() ? 'password' : 'text'" formControlName="password"
                                required />
                            <button type="button" matIconButton matSuffix (click)="passwordHideToggle($event)"
                                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passwordHide()">
                                <mat-icon>{{passwordHide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                            @if(this.loginFg.controls["password"].invalid
                            && (this.loginFg.controls["password"].touched || this.loginFg.controls["password"].dirty)
                            ) {
                            <mat-error>
                                @if(this.loginFg.controls["password"].errors?.["required"]) {
                                <span>Password is required.</span>
                                }
                                @else {
                                <span></span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </p>
                    <div class="w-100 my-3 d-flex justify-content-between align-items-baseline">
                        <mat-checkbox class="pias-label" formControlName="saveInfoCb">Remember me</mat-checkbox>
                        <a [routerLink]="'/forgot-password'" class="pias-link">Forgot Password?</a>
                    </div>
                    <p class="w-100">
                        <button type="submit" id="login-btn" class="btn" [disabled]="this.loginFg.invalid"
                            (click)="authenticateUser()">Login</button>
                    </p>
                    <p class="w-100">
                        New user?
                        <a [routerLink]="'/register-new-user'" class="pias-link">Register here</a>
                    </p>
                    <p class="w-100">
                        <button type="button" id="singpass-btn" class="btn invisible">Login with <img
                                src="assets/images/singpass-logo-white.svg" alt="SingPass" width="80" /></button>
                    </p>
                </form>
            </div>
        </div>

        <!-- Footer -->
        <div id="pias-footer">
            <p>© 2025 Professional Investment Advisory Services Pte Ltd</p>
        </div>
    </div>
</div>